import { Injectable } from '@angular/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { environment } from '../../environments/environment';
import { PT_FALLBACK } from './pt-fallback';

@Injectable()
export class AppMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): string {
    const { key } = params;

    // Tentar obter a tradução do mapa de fallback PT-PT
    const fallback = PT_FALLBACK[key];
    if (fallback) return fallback;

    // DEV: mostra a chave entre parênteses para fácil identificação
    if (!environment.production) return `[${key}]`;

    // PROD: devolve a chave (ou '' se preferires não mostrar nada)
    return key; // ou: return '';
  }
}
